import { STORAGE_KEYS } from 'constants/enums';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { Product } from 'types/IProducts';

import { mixpanelTrackingBlockTime } from '../constants';

const trackQuantityInput = selectedProduct => {
  const qtyInputLastTrackedTime = Number(
    localStorage.getItem(
      `${STORAGE_KEYS.PLACE_ORDER_PRICE_INPUT_TRACK_TIME}_${selectedProduct?.id}`
    ) || '0'
  );
  const timeNow = Date.now().valueOf();
  if (timeNow - qtyInputLastTrackedTime >= mixpanelTrackingBlockTime) {
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.ORDER_PLACEMENT.QUANTITY_ENTERED, {
      product_type: selectedProduct?.contract_type,
      product_name: selectedProduct?.symbol,
      side: 'buy',
      source: 'manual',
    });
    localStorage.setItem(
      `${STORAGE_KEYS.PLACE_ORDER_PRICE_INPUT_TRACK_TIME}_${selectedProduct?.id}`,
      String(timeNow)
    );
  }
};

const trackDropDownChange = (selectedProduct: Product, value: string) => {
  trackMixpanelEvent('Dropdown Clicked - Order Placement - Quantity', {
    contract_name: selectedProduct?.symbol,
    currency_name: value,
  });
};

export { trackDropDownChange, trackQuantityInput };
